import { Box, Button, HStack, Icon, Text } from "@chakra-ui/react";
import { forwardRef } from "react";
import { IoCheckmarkOutline } from "react-icons/io5";

const CommonOption = forwardRef(
  /**
   * @param {import(".").RenderOptionParams} props
   */
  function CommonOption(props, ref) {
    const {
      value,
      item,
      toggleValue,
      resolveItemName,
      resolveItemValue,
      focusPrev,
      focusNext,
    } = props;

    const itemValue = resolveItemValue({ item });

    return (
      <Box>
        <Button
          ref={ref}
          onClick={() => {
            toggleValue({ item });
          }}
          onKeyDown={(event) => {
            if (event.key === "ArrowUp") {
              event.preventDefault();
              focusPrev();
            }
            if (event.key === "ArrowDown") {
              event.preventDefault();
              focusNext();
            }
          }}
          alignItems="center"
          justifyContent="flex-start"
          variant="ghost"
          size="sm"
          w="100%"
          textAlign="left">
          {(value === itemValue ||
            (Array.isArray(value) && value?.includes?.(itemValue))) && (
            <HStack pr=".5rem">
              <Icon as={IoCheckmarkOutline} />
            </HStack>
          )}

          <Text
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
            as="span">
            {resolveItemName({ item })}
          </Text>
        </Button>
      </Box>
    );
  },
);

export default CommonOption;
